var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17003 7.40006C9.02003 7.40006 8.86003 7.34006 8.75003 7.22006L6.57006 5.04793V20.4C6.57006 20.73 6.30006 21 5.97006 21C5.64006 21 5.37006 20.73 5.37006 20.4V5.04787L3.19003 7.22006C2.96003 7.46006 2.58003 7.45006 2.34003 7.22006C2.10003 6.99006 2.11003 6.61006 2.34003 6.37006L5.54003 3.17006C5.77003 2.94006 6.15003 2.94006 6.39003 3.17006L9.59003 6.37006C9.82003 6.60006 9.82003 6.98006 9.59003 7.22006C9.48003 7.34006 9.32003 7.40006 9.17003 7.40006ZM21.97 12.5999H9.17001C8.84001 12.5999 8.57001 12.3299 8.57001 11.9999C8.57001 11.6699 8.84001 11.3999 9.17001 11.3999H21.97C22.3 11.3999 22.57 11.6699 22.57 11.9999C22.57 12.3299 22.3 12.5999 21.97 12.5999ZM9.17001 16.8001H17.97C18.3 16.8001 18.57 16.5301 18.57 16.2001C18.57 15.8701 18.3 15.6001 17.97 15.6001H9.17001C8.84001 15.6001 8.57001 15.8701 8.57001 16.2001C8.57001 16.5301 8.84001 16.8001 9.17001 16.8001ZM9.17001 21H13.97C14.3 21 14.57 20.73 14.57 20.4C14.57 20.07 14.3 19.8 13.97 19.8H9.17001C8.84001 19.8 8.57001 20.07 8.57001 20.4C8.57001 20.73 8.84001 21 9.17001 21Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.34af06a2db10747b45c219afb8d4eb93.svg";
export { ForwardRef as ReactComponent };